import { EntityModel } from '@/interfaces'
import {
  ALL_DESTINATIONS_QUERY,
  CREATE_DESTINATION_MUTATION,
  DELETE_DESTINATION_MUTATION,
  FORCE_DELETE_DESTINATION_MUTATION,
  SINGLE_DESTINATION_QUERY,
  UPDATE_DESTINATION_MUTATION,
} from './graphql'

const travelDestinationModel: EntityModel = {
  name: 'destination',
  namePlural: 'destinations',
  uniqueName: 'travelDestination',
  uniqueNamePlural: 'travelDestinations',
  path: 'travel/destination',
  baseUrl: '/travel/destinations',
  translationPrefix: 'entities:travelDestination.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_DESTINATIONS_QUERY,
    getSingle: SINGLE_DESTINATION_QUERY,
    create: CREATE_DESTINATION_MUTATION,
    update: UPDATE_DESTINATION_MUTATION,
    delete: DELETE_DESTINATION_MUTATION,
    forceDelete: FORCE_DELETE_DESTINATION_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:travelDestination.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    entryRequirements: {
      name: 'entryRequirements',
      label: 'entities:travelDestination.attributes.entryRequirements.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    medicalInformation: {
      name: 'medicalInformation',
      label: 'entities:travelDestination.attributes.medicalInformation.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    language: {
      name: 'language',
      label: 'entities:travelDestination.attributes.language.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    timeShift: {
      name: 'timeShift',
      label: 'entities:travelDestination.attributes.timeShift.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    climate: {
      name: 'climate',
      label: 'entities:travelDestination.attributes.climate.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    currency: {
      name: 'currency',
      label: 'entities:travelDestination.attributes.currency.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelDestinationModel
